import { FunctionComponent, h } from 'preact';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLocationArrow } from '@fortawesome/pro-regular-svg-icons/faLocationArrow';
import { useCallback } from 'preact/hooks';
import { useTranslation } from '../../hooks/use-translation';

interface Props {
	bounds: google.maps.LatLngBounds | google.maps.LatLngBoundsLiteral;
	map: google.maps.Map;
}

const MapAutoCenter: FunctionComponent<Props> = ({ bounds, map }) => {
	const { t } = useTranslation();
	const autoCenter = useCallback(() => bounds && map.panToBounds(bounds, 100), [map, bounds]);

	return (
		<div className="map-auto-center" data-testid="map-auto-center" onClick={autoCenter}>
			<FontAwesomeIcon
				icon={faLocationArrow}
				aria-hidden="false"
				role="button"
				aria-label={t('MAP_AUTO_CENTER')}
			/>
		</div>
	);
};

export default MapAutoCenter;
